(function(){
  function fmt(d, lang){
    try {
      return d.toLocaleDateString(lang || 'fr-FR', { day:'2-digit', month:'short' });
    } catch(e){
      return d.toLocaleDateString('fr-FR', { day:'2-digit', month:'short' });
    }
  }
  function addDays(d,n){ var x=new Date(d); x.setDate(x.getDate()+n); return x; }

  // -------------------------------------------------
  // NOUVELLE LOGIQUE :
  // Production = 1er jour du mois suivant
  // Livraison = production + 21 jours
  // -------------------------------------------------
  function computeDates(today){
    const prod = new Date(today.getFullYear(), today.getMonth() + 1, 1); // 1er du mois suivant
    const ship = prod; // ton code affichait la production sous la clé "ship"
    const delivMin = addDays(prod, 21);
    const delivMax = addDays(prod, 21); // si tu veux une fourchette, change ici
    return { today, prod, ship, delivMin, delivMax };
  }

  function render(container){
    var lang = container.getAttribute('data-lang') || document.documentElement.lang || 'fr-FR';
    var d = computeDates(new Date());

    // styles injectés une seule fois
    if (!document.getElementById('edd-progress-css')){
      var css = `
      .edd-steps{display:flex;align-items:center;gap:12px;margin:12px 0}
      .edd-step{text-align:center;flex:1}
      .edd-bullet{width:32px;height:32px;border-radius:50%;border:2px solid currentColor;display:inline-flex;align-items:center;justify-content:center;font-weight:700}
      .edd-line{height:4px;flex:1;background:currentColor;opacity:.25}
      .edd-line.filled{opacity:1}
      .edd-step small{display:block;opacity:.7}
      `;
      var s = document.createElement('style');
      s.id = 'edd-progress-css';
      s.appendChild(document.createTextNode(css));
      document.head.appendChild(s);
    }

    var stepIndex = d.today >= d.delivMax ? 3 : d.today >= d.ship ? 2 : 1;

    container.innerHTML = `
      <div class="edd-steps" role="group" aria-label="Statut de livraison">
        <div class="edd-step">
          <div class="edd-bullet" aria-current="${stepIndex===1?'step':false}">1</div>
          <div><strong>Achat</strong><small>${fmt(d.today,lang)}</small></div>
        </div>
        <div class="edd-line ${stepIndex>1?'filled':''}"></div>
        <div class="edd-step">
          <div class="edd-bullet" aria-current="${stepIndex===2?'step':false}">2</div>
          <div><strong>Production</strong><small>${fmt(d.prod,lang)}</small></div>
        </div>
        <div class="edd-line ${stepIndex>2?'filled':''}"></div>
        <div class="edd-step">
          <div class="edd-bullet" aria-current="${stepIndex===3?'step':false}">3</div>
          <div><strong>Livraison</strong><small>${fmt(d.delivMin,lang)}</small></div>
        </div>
      </div>
    `;
  }

  function init(){
    document.querySelectorAll('.edd-progress').forEach(render);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
